export enum CompanyPresetEventTypeEnum {
  currentCompanyPresetSelected = 0,
  currentCompanyPresetChange = 1,
}
